<div class="authenticating-screen" *ngIf="auth.authenticating">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>
<app-modal></app-modal>
<router-outlet></router-outlet>
